export const CTA_CSS = `
.hp-cta { background: var(--color-teal); padding: 88px 0; text-align: center; }
.hp-cta__inner { max-width: 680px; margin: 0 auto; padding: 0 40px; }
.hp-cta__title {
  font-family: var(--font-serif);
  font-size: clamp(2rem, 4vw, 3rem); font-weight: 300;
  color: var(--color-ivory); margin-bottom: 16px; line-height: 1.15;
}
.hp-cta__sub { font-size: 14px; color: rgba(245,242,236,0.72); margin-bottom: 40px; line-height: 1.7; }
.hp-cta__actions { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; }
.hp-cta__phone {
  display: inline-flex; align-items: center; gap: 10px;
  font-family: var(--font-serif); font-size: 1.4rem; font-weight: 300;
  color: var(--color-ivory); letter-spacing: 0.04em; margin-bottom: 40px;
}
.hp-cta__phone svg { color: var(--color-gold); }
`
